import { coordToLatLng } from "./coordToLatLng";

export function calculateMarkerDistance (cameraPosition, markerCoords) {
    if (!window.google.maps) {
        console.warn("Maps API not loaded");
        return null;
    }
    const targetLatLng = coordToLatLng(markerCoords);

    return window.google.maps.geometry.spherical.computeDistanceBetween(
        cameraPosition, 
        targetLatLng
    );
}
